import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Success from "../../assets/green_checkmark.png";
import { AiOutlineExclamation } from "react-icons/ai";
import { BsExclamationCircle } from "react-icons/bs";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export const successNotfiy = (text, onSuccessClose?) => {
  toast.success(text, {
    toastId: "success",
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    theme: "light",
    onClose: onSuccessClose,
    className:
      "rounded-full !bg-brand-50 !overflow-visible !w-[400px] !min-h-full",
    bodyClassName: "text-base font-medium text-brand-700 px-4 !max-w-[85%]",
    progressClassName: "bg-brand-700",
    icon: (
      <IoMdCheckmarkCircleOutline className="text-brand-700 stroke-[10px] w-4 h-4" />
    ),
    closeButton: (
      <button className="focus:outline-none absolute top-[19px] right-6 text-customGreen-lightLabel text-sm hover:text-brand-700">
        &#10005;
      </button>
    ),
  });
};
export const errorNotfiy = (text, onErrorClose?) => {
  toast.error(text, {
    toastId: "error",
    position: "bottom-center",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    onClose: onErrorClose,
    className:
      "rounded-full !bg-customRed-light !overflow-visible !min-h-full !w-[400px]",
    bodyClassName:
      "text-base font-medium text-customRed-label px-4 ml-2 !max-w-[86%]",
    progressClassName: "bg-customRed-label",
    icon: <BsExclamationCircle className="text-customRed-label w-4 h-4" />,
    closeButton: (
      <button className="focus:outline-none absolute top-[19px] right-6 text-customRed-lightLabel text-sm hover:text-customRed-label">
        &#10005;
      </button>
    ),
  });
};
export default function Alert() {
  return <ToastContainer />;
}
